import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_58.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter63.json";
import Head from "next/head";
export default function Chapter_63() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
      <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Theurgy aligns the soul with divine harmony; sorcery distorts spiritual forces through coercion and imbalance."
        ></meta>
        <meta
          property="og:title"
          content="Theurgy vs. Sorcery: Iamblichus’s Path of Divine Harmony"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="This chapter explores the profound divide between Iamblichus’s theurgy and sorcery or goetia. Theurgy fosters divine union, humility, and alignment with cosmic order, while sorcery manipulates spiritual forces for personal gain. Drawing on historical examples and philosophical principles, it reveals why these practices are irreconcilable—and why our school rejects coercive magic entirely."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=63"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=63"
        ></meta>
        <meta
          name="twitter:title"
          content="Theurgy vs. Sorcery: Iamblichus’s Path of Divine Harmony"
        ></meta>
        <meta
          name="twitter:description"
          content="Iamblichus taught that theurgy aligns the soul with divine harmony, opposing sorcery’s coercion and imbalance. This chapter contrasts their intent, ethics, and outcomes, showing how curse tablets, chthonic rituals, and manipulative magic stand apart from the theurgist’s path. Our school follows his vision, embracing humility and divine grace over domination of spiritual forces."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=63" />
      </Head>
      <Common_html BlockData={BlockData} />
    </>
  );
}
